//
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import { React, useState } from 'react';

//
// ─── IMPORTING UTILS ───────────────────────────────────────
//
import Api from '../../contexts/Api';
import { useNotification } from '../UseNotification';

//
// ─── IMPORTING FONTAWESOME ICONS ───────────────────────────────────────
//
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-duotone-svg-icons';

const MIME_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

//
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const ExportServer = ({ endpoint, fileName, label = 'Export XLSX', query = {} }) => {
  // FONTAWESOME
  library.add(faDownload)

  //
  // ─── STATE DECLARATION ───────────────────────────────────────
  //
  const [pending, setPending] = useState(false)

  // Notification user
  const { notification } = useNotification()

  //
  // ─── TELECHARGEMENT ───────────────────────────────────────
  //
  const handleExportClick = async () => {
    if (pending) return

    setPending(true)
    const getExport = await Api({ endpoint, method: 'GET', query })
    setPending(false)

    if (!getExport || !getExport.success) {
      return notification({ variant: 'error', message: (getExport && getExport.message) || 'Une erreur est survenue' })
    }

    // Le type MIME doit être celui d'un xlsx : le composant historique annonce
    // un PDF, ce qui perturbe certains navigateurs à l'ouverture.
    const today = new Date().toISOString().split('T')[0];
    const link = document.createElement('a');
    link.href = `data:${MIME_XLSX};base64,${getExport.buffer}`;
    link.download = `${fileName}_${today}.xlsx`;
    link.click();
  };

  //
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <button className='exportButton' onClick={handleExportClick} disabled={pending}>
    <FontAwesomeIcon icon={faDownload} /> {pending ? 'Génération…' : label}
  </button>;
}

export default ExportServer;
